import moment from 'moment';

/**
 * 字符串分割成数组
 *
 * @export
 * @param {string} str 字符串
 * @param {string} separator 分割的符号
 */
export function splitToArr(str, separator = ',') {
  if (!str) {
    return [];
  }

  let arr = null;
  const hasSemi = str.indexOf(';') !== -1;
  if (hasSemi) {
    arr = str.split(';');
  } else {
    arr = str.split(separator);
  }

  return arr;
}

/**
 * 截取银行卡账号后4位
 * @param {*} bankNumber
 */
export function bankNumberStr(bankNumber) {
  return bankNumber.length > 4 ? bankNumber.substring(bankNumber.length - 4) : bankNumber;
}

/**
 * 递归成树状结构
 * 递归的多种形式可参考：https://blog.csdn.net/susuzhe123/article/details/95353403
 * @param
 * data 一维数据
 * parentId 层级标识
 * parentIdKey 检索字段值
 * */
export function recursiveTree(data, parentId, parentIdKey = 'parentId') {
  if (!(data instanceof Array)) return [];
  function loop(pid) {
    const list = [];
    for (let i = 0; i < data.length; i += 1) {
      const item = data[i];
      if (item[parentIdKey] === pid) {
        item.children = loop(item.id);
        list.push(item);
      }
    }
    return list.length > 0 ? list : null;
  }
  return loop(parentId);
}

/**
 * 获取昨天
 */
export function getYesterday() {
  return moment().subtract(1, 'days').format('YYYY-MM-DD');
}

/**
 * 获取几天前
 * 0 为获取当天
 */
export function getDayValue(day = 1) {
  if (day === 0) {
    return moment().format('YYYY-MM-DD');
  }
  return moment().subtract(day, 'days').format('YYYY-MM-DD');
}

/**
 * 获取当月第一天
 */
export function getMonthStart() {
  return moment().startOf('month').format('YYYY-MM-DD');
}
